import React from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./Energize.css";
// import img7 from '../../assets/Swatch.svg'
import { Link } from "react-router-dom";
import Footer from "../footer/Footer";

const Energize = () => {
  return (
    <>
      <div>
        <div className="energizebackGroud">
          <div className="container">
            <div className="row flex-direction-column">
              <div className="col-xl-5 col-md-6 teleportBtnSwapDiv">
                <Link to="/teleport">
                  <button className="btn teleportBtnSwap1" style={{borderRadius:'0', borderTopLeftRadius:'7px', borderBottomLeftRadius:'7px'}}>Teleport</button>
                </Link>
                <Link to="">
                  <button className="btn teleportBtnSwap2">Energize</button>
                </Link>
              </div>
              <div className="col-xl-5 col-lg-6 col-md-7 energizeOuter">
                <div className="aknsakn">
                  <div className="energizeHeadingDiv">
                    <p className="energizeHeading">Energize</p>
                  </div>
                  <div className="ebergizeInput">
                    <form action="/action_page.php">
                      <div className="form-group energizeDiv2">
                        {/* <label for='email'>Email address:</label> */}
                        <input
                          type="email"
                          className="form-control energizeForm"
                          placeholder="Enter TX Hash"
                          id="email"
                        />
                      </div>
                    </form>
                  </div>

                  <div className="energizeDiv1">
                    <button className="btn btn-success energizeBtn">
                      Energize
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="outersgsgsgg">
          <img src={img7} />
          </div> */}
      </div>
      <Footer />
    </>
  );
};

export default Energize;
